import "../styles/button.css";

function Button() {
  return <button className="btn-error">Back to homepage</button>;
}

export default Button;
